import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Link from 'react-router-dom/Link';
import Alert from 'react-bootstrap/Alert';
import Breadcrumb from 'react-bootstrap/Breadcrumb'
var firebase = require('firebase/app');
// Add the Firebase products that you want to use
require('firebase/auth');

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.showPasswordAlert = this.showPasswordAlert.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);

    this.state = {
      showAlert: '',
      alertText: [],
      accEmail: '',
      accPass: '',
    };
  }

  showPasswordAlert() {
    if (this.state.showAlert) {
      return (
        <Alert variant="danger">
          <Alert.Heading> Please fix the following problems: </Alert.Heading>
          <ul>
            {this.state.alertText.map(alertText => (
              <li> {alertText} </li>
            ))}
          </ul>
        </Alert>
      );
    } else {
      return <div></div>;
    }
  }

  handleFormSubmit(e) {
    e.preventDefault();

    let alertNeeded = false,
      alerts = [];

    if (this.state.accEmail === '') {
      alertNeeded = true;
      alerts = alerts.concat('Please fill in the email');
    }

    if (this.state.accPass === '') {
      alertNeeded = true;
      alerts = alerts.concat('Please enter the password');
    }

    let _this = this;

    if (alertNeeded) {
      this.setState({ showAlert: true, alertText: alerts });
    } else {
      firebase
        .auth()
        .signInWithEmailAndPassword(_this.state.accEmail, _this.state.accPass)
        .then(e => {
          console.log('Username: ' + e.user.displayName);
          console.log(e.user.photoURL);
          this.props.loginUser(e.user.photoURL, e.user.displayName);
          this.props.history.push('/my_account');
        })
        .catch((error) => {
          alertNeeded = true;
          alerts = alerts.concat(
            'The email entered or the password was incorrect'
          );
          this.setState({ showAlert: true, alertText: alerts });
        });
    }
  }

  /**
   * Check if the user has entered an email and clicked the 'forgot password' button
   * Then, send a reset email to the user
   * @param {*} evt 
   */
  handleForgotPassword(evt) {
    evt.preventDefault();
    if(this.state.accEmail === '') {
      this.setState({ showAlert: true, alertText: ['Please enter an email to reset your password'] });
      return;
    }

    var auth = firebase.auth();

    auth.sendPasswordResetEmail(this.state.accEmail).then(() => {
      this.setState({ showAlert: true, alertText: ['An email has been sent to reset your password'] });
    }).catch((error) => {
      this.setState({ showAlert: true, alertText: ['Check that you entered a valid email', 'Unable to connect to server: your internet connection may be unstable'] });
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      showAlert: false,
    });
  }

  handleToggle(e) {
    console.log('What');
    this.setState({ termsAgree: !this.state.termsAgree });
  }

  render() {
    return !this.props.isAuthenticated ?
      <div className="container">
        <this.showPasswordAlert />
        <Form onSubmit={this.handleFormSubmit}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              name="accEmail"
              onChange={this.handleChange}
              placeholder="Enter email"
            />
            <Form.Text className="text-muted"></Form.Text>
          </Form.Group>
          <Form.Group controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="accPass"
              onChange={this.handleChange}
              placeholder="Password"
            />
            <Button variant="link" onClick={this.handleForgotPassword}> 
              Forgot password? 
            </Button>
          </Form.Group>
          <Button variant="primary" type="submit"> 
            Let's go!
          </Button>
        </Form>
        <br />
          <Link to="/signup"> Need an account? Sign up. </Link>
      </div>
    :
      <div className="container">
              <Alert variant="danger"> You are already logged in! </Alert>
      </div>
  }
}

export default LoginPage;
